import React, { useState, useEffect } from "react";
import "../styles/feedback.css";
import BackButton from "../components/BackButton";
import axios from "../axios";
import { useNavigate } from "react-router-dom";

const TYPES = ["bug", "idée", "amélioration", "avis général", "problème compte", "problème scan"];

const Feedback = () => {
  const stored = (() => {
    try { return JSON.parse(localStorage.getItem("user")) || {}; } catch { return {}; }
  })();
  const userId = stored._id || stored.id || null;
  const userRole = stored.role || "guest";
  const isLoggedIn = !!userId;

  const [form, setForm] = useState({
    type: "",
    rating: 0,
    title: "",
    message: "",
    email: ""
  });
  const navigate = useNavigate();
  useEffect(() => { window.scrollTo(0, 0); }, []);
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState(null);

  const set = (key, val) => setForm(prev => ({ ...prev, [key]: val }));

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!form.type) { setError("Choisis un type de retour."); return; }
    if (!form.title.trim()) { setError("Le titre est requis."); return; }
    if (!form.message.trim()) { setError("Le message est requis."); return; }
    if (form.message.length > 2000) { setError("Le message dépasse 2000 caractères."); return; }

    setLoading(true);
    setError(null);
    try {
      await axios.post("/feedback", {
        userId,
        userRole,
        type: form.type,
        rating: form.rating || null,
        title: form.title.trim(),
        message: form.message.trim(),
        email: !isLoggedIn && form.email.trim() ? form.email.trim() : null,
        pageConcerned: window.location.href,
        device: navigator.userAgent,
        appVersion: "1.0.3"
      });
      setSuccess(true);
      window.scrollTo({ top: 0, behavior: "smooth" });
    } catch (err) {
      setError(err.response?.data?.error || "Erreur lors de l'envoi. Réessaie.");
    } finally {
      setLoading(false);
    }
  };

  if (success) {
    return (
      <div className="fb-wrapper">
        <div className="fb-card fb-success">
          <div className="fb-success-icon">🎉</div>
          <h2 className="fb-success-title">Merci pour ton retour !</h2>
          <p className="fb-success-text">Ton message a bien été reçu. On en prend note.</p>
          <button
            onClick={() => navigate(-1)}
            style={{ background: "none", border: "none", color: "#e11d48", fontWeight: 700, fontSize: "14px", cursor: "pointer", display: "flex", alignItems: "center", gap: "4px", margin: "0 auto" }}
          >
            ← Retour
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="fb-wrapper">
      <div className="fb-card">
        <BackButton fallback="/" />
        <h1 className="fb-title">Ton retour</h1>
        <p className="fb-subtitle">Un bug ? Une idée ? Dis-nous tout.</p>

        <form onSubmit={handleSubmit} className="fb-form">

          {/* Type */}
          <div className="fb-field">
            <label className="fb-label">Type de retour *</label>
            <select
              className="fb-select"
              value={form.type}
              onChange={e => set("type", e.target.value)}
              required
            >
              <option value="">-- Choisir --</option>
              {TYPES.map(t => (
                <option key={t} value={t}>{t.charAt(0).toUpperCase() + t.slice(1)}</option>
              ))}
            </select>
          </div>

          {/* Rating */}
          <div className="fb-field">
            <label className="fb-label">Note (optionnel)</label>
            <div className="fb-stars">
              {[1, 2, 3, 4, 5].map(n => (
                <button
                  key={n}
                  type="button"
                  className={`fb-star ${form.rating >= n ? "fb-star--active" : ""}`}
                  onClick={() => set("rating", form.rating === n ? 0 : n)}
                  aria-label={`${n} étoile${n > 1 ? "s" : ""}`}
                >
                  ★
                </button>
              ))}
            </div>
          </div>

          {/* Title */}
          <div className="fb-field">
            <label className="fb-label">Titre *</label>
            <input
              className="fb-input"
              type="text"
              placeholder="En une phrase…"
              value={form.title}
              onChange={e => set("title", e.target.value)}
              maxLength={100}
              required
            />
          </div>

          {/* Message */}
          <div className="fb-field">
            <label className="fb-label">Message *</label>
            <textarea
              className="fb-textarea"
              placeholder="Décris ton retour en détail…"
              value={form.message}
              onChange={e => set("message", e.target.value)}
              maxLength={2000}
              rows={5}
              required
            />
            <span className="fb-counter">{form.message.length} / 2000</span>
          </div>

          {/* Email (uniquement si non connecté) */}
          {!isLoggedIn && (
            <div className="fb-field">
              <label className="fb-label">Email (optionnel)</label>
              <input
                className="fb-input"
                type="email"
                placeholder="Pour qu'on puisse te répondre"
                value={form.email}
                onChange={e => set("email", e.target.value)}
              />
            </div>
          )}

          {error && <p className="fb-error">{error}</p>}

          <button type="submit" className="fb-btn" disabled={loading}>
            {loading ? "Envoi…" : "Envoyer mon retour"}
          </button>
        </form>
      </div>
    </div>
  );
};

export default Feedback;
